import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class PoliciesService {

    constructor(private api: ApiService) {
    }

    getList() {
        return this.api.get('/filemanager/product-config-policies.json');
    }

    update(payload) {
        return this.api.post('/filemanager/product-config-policies', payload).pipe(map(({result}) => result));
      }

    create(value) {
        return this.api.post('/admin/localizations', value).pipe(map(({result}) => result));
    }


    delete(productId, ruleName) {
            return this.api.delete('/filemanager/product-config-policies/' + productId + '/' + ruleName).pipe(map(response => response));
    }

    uploadImport(file) {
      return this.api.post('/filemanager/import-policies', {policies: file}).pipe(map(response => response));
    }

    getExport() {
      return this.api.post(`/filemanager/export-policies`).pipe(map(response => response));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/policies.service.ts